import type { TournamentsApi } from '@/v2/api/metadata/tournaments'
import { buildFeedConfigTab } from '@/v2/kits/feed-config'
import { createTournamentFeedConfigApi } from './tournament-feed-config-api'

/** Saves are inline (toggle / drawer); dialog footer Save is a no-op on this tab. */
export function createFeedConfigTab(tournaments: TournamentsApi) {
  return buildFeedConfigTab(createTournamentFeedConfigApi(tournaments), {
    label: 'Feed update configurations',
  })
}
